import moment from 'moment';

export default function makeDataLevel(d, pageIndex, pageSize, index) {
  return {
    rnum: pageIndex * pageSize + index + 1,
    areaNo: d.locationNo,
    areaNm: d.locationNm,
    modelNm: d.module.modelNm,
    wind: d.wind,
    statusCode: d.statusCode,
    status: 'blue',
    battery: d.battery,
    regDate: moment(d.rgstDt).format('YYYY-MM-DD HH:mm:ss'),
  };
}
